import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'
import Home from '../views/Home.vue'
import Layout from '../layout/index.vue'
// import GoodsList from '../views/GoodsList.vue'
import login from '../views/login.vue'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'login',
    component: login
  },
  {
    path: '/index',
    name: 'Layout',
    component: Layout,
    children: [
      {
        path: '/',
        name: 'IndexHome',
        component: Home
      },
      // {
      //   path: '/userManagement',
      //   name: 'userManagement',
      //   component: () => import('../views/userManagement.vue'),
      //   meta: {
      //     keepAlive: false
      //   }
      // },
      // {
      //   path: '/campusMicroStore',
      //   name: 'campusMicroStore',
      //   component: () => import('../views/campusMicroStore.vue'),
      //   meta: {
      //     keepAlive: true
      //   }
      // },
      // 商品详情
      // {
      //   path: '/detailsGoods',
      //   name: 'detailsGoods',
      //   component: () => import('../views/detailsGoods.vue'),
      //   meta: {
      //     keepAlive: false
      //   }
      // },
      // 批次管理
      // {
      //   path: '/batchManagement',
      //   name: 'batchManagement',
      //   component: () => import('../views/batchManagement.vue'),
      //   meta: {
      //     keepAlive: false
      //   }
      // },
      // 学生列表
      // {
      //   path: '/studentManagement',
      //   name: 'studentManagement',
      //   component: () => import('../views/studentManagement.vue'),
      //   meta: {
      //     keepAlive: false
      //   }
      // },
      // 退款申请
      // {
      //   path: '/applicationRefund',
      //   name: 'applicationRefund',
      //   component: () => import('../views/applicationRefund.vue'),
      //   meta: {
      //     keepAlive: false
      //   }
      // },
      // 角色管理
      // {
      //   path: '/roleManagement',
      //   name: 'roleManagement',
      //   component: () => import('../views/roleManagement.vue'),
      //   meta: {
      //     keepAlive: false
      //   }
      // },
      // 菜单管理
      // {
      //   path: '/menuManagement',
      //   name: 'menuManagement',
      //   component: () => import('../views/menuManagement.vue'),
      //   meta: {
      //     keepAlive: false
      //   }
      // },
      // 用户管理
      // {
      //   path: '/userManagement',
      //   name: 'userManagement',
      //   component: () => import('../views/userManagement.vue'),
      //   meta: {
      //     keepAlive: false
      //   }
      // },
      // {
      //   path: '/inChargeManagement',
      //   name: 'inChargeManagement',
      //   component: () => import('../views/inChargeManagement.vue'),
      //   meta: {
      //     keepAlive: false
      //   }
      // },
    ]
  },
  // {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
router.afterEach(() => {
  // //console.log(to, '-----', from, '---',);
  // //console.log(1111, store.state.menu.length);
  if (store.state.menu.length > 0) {
    let data = store.state.menu
    data.forEach(item => {
      //console.log('---------------',item)

      if (item.menuType === 1) {
        router.addRoute('Layout', {
          path: item.url,
          name: item.url.slice(1),
          component: () => import('../views' + item.url + '.vue'),
          meta: {
            keepAlive: false
          }
        })
        item.child.forEach((v) => {
          // //console.log('v', v);
          if (v.menuType === 3) {
            router.addRoute('Layout', {
              path: v.url,
              name: v.url.slice(1),
              component: () => import('../views' + v.url + '.vue'),
              meta: {
                keepAlive: false
              }
            })
          }
        })
      } else if (item.menuType === 0) {
        item.child.forEach(val => {
          // //console.log(val);
          router.addRoute('Layout', {
            path: val.url,
            name: val.url.slice(1),
            component: () => import(`../views${val.url}.vue`),
            meta: {
              keepAlive: false
            }
          })
          val.child.forEach((v) => {
            // //console.log('v', v);
            if (v.menuType === 3) {
              router.addRoute('Layout', {
                path: v.url,
                name: v.url.slice(1),
                component: () => import('../views' + v.url + '.vue'),
                meta: {
                  keepAlive: false
                }
              })
            }
          })
        })
      }
    });

  }
})

export default router
